import { useState, useEffect } from 'react';

/** Returns a live Date updated every second — mirrors the HTML prototype's useClock. */
export function useClock(): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => { setNow(new Date()); }, 1000);
    return () => { clearInterval(id); };
  }, []);
  return now;
}
